import { RootState } from '@/shared/store'

import { dropdownsAdapter } from './dropdownsAdapter'

export const dropdownsSelector = dropdownsAdapter.getSelectors<RootState>(
  (state) => state.dropdowns,
)
